import React from "react";
import StandardModal from "./shared/StandardModal";

function GoogleSyncSuccessModal({ open, close, syncStats, renderSyncStats }) {
	return (
		<StandardModal size="medium" title={"Google sync successful"} open={open} close={close}>
			<div className="GoogleSyncSuccessModal">
				<div className="text-bold">Thanks for your patience. You can now continue using Classwize.</div>
				{renderSyncStats(syncStats, "Details")}
			</div>
		</StandardModal>
	);
}

export default GoogleSyncSuccessModal;
